import { Box, SegmentedControl, Stack, TFCard } from '@tf/ui';
import type React from 'react';
import { useState } from 'react';

import { AdverseMedia } from './AdverseMedia';
import { KeyInfoTable } from './KeyInfoTable';
import { SanctionList } from './SanctionList';
import type { ResultHit } from './types';

const TABS = {
	KEY_INFO: {
		label: 'Key info',
		value: 'keyInfo',
	},
	ADVERSE_MEDIA: {
		label: 'Adverse media',
		value: 'adverseMedia',
	},
} as const;

interface Props {
	hit: ResultHit;
	withInnerCard?: boolean;
}

export const ScreeningResultCard: React.FC<Props> = ({ hit, withInnerCard }) => {
	const [selectedTab, setSelectedTab] = useState('keyInfo');

	return (
		<Stack>
			<SegmentedControl
				value={selectedTab}
				onChange={(value: string) => setSelectedTab(value)}
				fullWidth
				data={Object.values(TABS)}
			/>
			{selectedTab === TABS.KEY_INFO.value && (
				<InnerCard withCard={withInnerCard}>
					<Stack gap="24px">
						<KeyInfoTable keyInfo={hit.keyInfo} />
						<SanctionList title="Sаnctions list" sanctionList={hit.sanctionList} />
						<SanctionList title="Warning list" sanctionList={hit.warningList} />
						<SanctionList title="Fitness & Probity" sanctionList={hit.fitnessProbityList} />
						<SanctionList title="PEP positions" sanctionList={hit.pepList} />
						<SanctionList title="PEP Class 1 positions" sanctionList={hit.pepClass1List} />
						<SanctionList title="PEP Class 2 positions" sanctionList={hit.pepClass2List} />
						<SanctionList title="PEP Class 3 positions" sanctionList={hit.pepClass3List} />
						<SanctionList title="PEP Class 4 positions" sanctionList={hit.pepClass4List} />
					</Stack>
				</InnerCard>
			)}
			{selectedTab === TABS.ADVERSE_MEDIA.value && (
				<InnerCard withCard={withInnerCard}>
					<AdverseMedia adverseMedia={hit.adverseMedia} />
				</InnerCard>
			)}
		</Stack>
	);
};

interface InnerCardProps {
	children: React.ReactNode;
	withCard?: boolean;
}

const InnerCard: React.FC<InnerCardProps> = ({ children, withCard = true }) => {
	if (withCard) {
		return (
			<TFCard>
				<Box sx={{ padding: '1rem' }}>{children}</Box>
			</TFCard>
		);
	}

	return <>{children}</>;
};
